import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventDropdownItem } from '../../models/common/event-dropdown-item';

@Component({
  selector: 't4-event-dropdown',
  templateUrl: './event-dropdown.component.html',
  styleUrls: ['./event-dropdown.component.scss'],
  standalone: false
})
export class EventDropdownComponent implements OnInit, OnChanges {

  @Input() events: EventDropdownItem[] = [];
  @Input() showAllEventsOption: boolean = false;
  @Input() selectedEventId: number | null = null;
  @Input() placeholder: string = 'ADMINISTRATION.TICKETS.FILTER.PLACEHOLDER.ALLEVENTS';
  @Input() disabled: boolean = false;

  @Output() selectionChange = new EventEmitter<number | null>();
  @Output() selectedEventIdChange = new EventEmitter<number | null>();

  displayedEvents: (EventDropdownItem | { id: null; name: string; startDateTime?: string })[] = [];

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.buildDisplayedEvents();
  }

  ngOnChanges() {
    this.buildDisplayedEvents();
  }

  private buildDisplayedEvents() {
    this.displayedEvents = [];

    if (this.showAllEventsOption) {
      this.displayedEvents.push({
        id: null,
        name: this.translate.instant('ADMINISTRATION.TICKETS.FILTER.PLACEHOLDER.ALLEVENTS')
      });
    }

    this.displayedEvents.push(...this.events);
  }

  formatEventDisplay(event: EventDropdownItem | { id: null; name: string }): string {
    if (!event) {
      return this.translate.instant('ADMINISTRATION.TICKETS.FILTER.PLACEHOLDER.ALLEVENTS');
    }
    if (event.id === null) {
      return event.name;
    }

    const typedEvent = event as EventDropdownItem;
    return `${typedEvent.id} - ${typedEvent.name} | ${this.formatDateTime(typedEvent.startDateTime)}`;
  }

  private formatDateTime(dateTime: Date | string): string {
    const date = new Date(dateTime);
    const dateStr = date.toLocaleString(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).replace(/\//g, '-');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${dateStr} ${hours}:${minutes}`;
  }

  onSelectionChange(event: EventDropdownItem | null) {
    this.selectedEventId = event?.id ?? null;
    this.selectedEventIdChange.emit(this.selectedEventId);
    this.selectionChange.emit(this.selectedEventId);
  }

  getSelectedEventItem(): EventDropdownItem | { id: null; name: string } | undefined {
    return this.displayedEvents.find(e => e.id === this.selectedEventId);
  }
}
